import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Check, X, Clock, User } from 'lucide-react';

const statusConfig = {
  full_day: { label: 'Full Day', className: 'bg-[#2E4632]/10 text-[#2E4632] border-[#2E4632]/20' },
  half_day: { label: 'Half Day', className: 'bg-[#D97706]/10 text-[#D97706] border-[#D97706]/20' },
  absent: { label: 'Absent', className: 'bg-[#BC4749]/10 text-[#BC4749] border-[#BC4749]/20' }
};

const StatusBadge = ({ status }) => {
  const config = statusConfig[status] || statusConfig.absent;
  return <Badge className={`${config.className} border`}>{config.label}</Badge>;
};

export const AttendanceWorkerRow = ({
  worker,
  currentStatus,
  overtimeHours,
  saving,
  fmt,
  onMark,
  onOvertimeChange
}) => (
  <div
    data-testid={`attendance-row-${worker.id}`}
    className="p-4 bg-[#F4F4F0] rounded-lg space-y-3"
  >
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-[#2E4632] flex items-center justify-center">
          <User className="w-5 h-5 text-white" />
        </div>
        <div>
          <p className="font-medium text-[#1C1C1E]">{worker.name}</p>
          <p className="text-sm text-[#5C5C5C]">{fmt(worker.daily_wage)}/day</p>
        </div>
      </div>
      {currentStatus && <StatusBadge status={currentStatus} />}
    </div>

    <div className="flex flex-wrap gap-2">
      <Button
        size="sm"
        data-testid={`mark-full-${worker.id}`}
        disabled={saving}
        onClick={() => onMark(worker.id, 'full_day', overtimeHours)}
        className={`h-10 px-4 ${
          currentStatus === 'full_day'
            ? 'bg-[#2E4632] text-white'
            : 'bg-white border border-[#2E4632] text-[#2E4632] hover:bg-[#2E4632] hover:text-white'
        }`}
      >
        <Check className="w-4 h-4 mr-1" /> Full Day
      </Button>
      <Button
        size="sm"
        data-testid={`mark-half-${worker.id}`}
        disabled={saving}
        onClick={() => onMark(worker.id, 'half_day', overtimeHours)}
        className={`h-10 px-4 ${
          currentStatus === 'half_day'
            ? 'bg-[#D97706] text-white'
            : 'bg-white border border-[#D97706] text-[#D97706] hover:bg-[#D97706] hover:text-white'
        }`}
      >
        <Clock className="w-4 h-4 mr-1" /> Half Day
      </Button>
      <Button
        size="sm"
        data-testid={`mark-absent-${worker.id}`}
        disabled={saving}
        onClick={() => onMark(worker.id, 'absent', 0)}
        className={`h-10 px-4 ${
          currentStatus === 'absent'
            ? 'bg-[#BC4749] text-white'
            : 'bg-white border border-[#BC4749] text-[#BC4749] hover:bg-[#BC4749] hover:text-white'
        }`}
      >
        <X className="w-4 h-4 mr-1" /> Absent
      </Button>
    </div>

    {(currentStatus === 'full_day' || currentStatus === 'half_day') && (
      <div className="flex items-center gap-3 pt-2">
        <Label className="text-sm text-[#5C5C5C] whitespace-nowrap">Overtime (hrs):</Label>
        <Input
          type="number"
          min="0"
          max="8"
          step="0.5"
          data-testid={`overtime-input-${worker.id}`}
          value={overtimeHours}
          onChange={(e) => onOvertimeChange(worker.id, parseFloat(e.target.value) || 0)}
          onBlur={(e) => onMark(worker.id, currentStatus, parseFloat(e.target.value) || 0)}
          className="w-20 h-10 border-[#D1D1CD]"
        />
      </div>
    )}
  </div>
);
